import { v4 as uuid4 } from 'uuid'
import { MESSAGES, USER_AUTHENTICATION_TYPE } from '../utils/constants'
import { MIDDLELAYER_API, SYNDEO_API } from '../utils/constants/endpoints'
import { AXIOS_METHODS } from '../utils/constants/enum'
import { setLocalState } from '../utils/local-storage'
import {
    AuthResponse,
    IMiddleLayerAuthenticationMultiAccountPayload,
    IMiddleLayerAuthenticationPayloadI,
    IMiddleLayerAuthenticationPayloadII,
    InvalidOtpResponse,
    RefreshTokenPayload,
    RefreshTokenResponse,
    SignInFormTypes,
    ValidateOtpPayload,
    ValidateOtpResponse,
} from '../utils/types/auth'
import { Axios } from './axios'

export const refreshTokenFromMiddleLayer = async (refreshToken: string) => {
    const request = {
        refreshToken: refreshToken,
    }
    const response = await Axios.middleLayerApiCall<any, any>(
        AXIOS_METHODS.POST,
        MIDDLELAYER_API.REFRESH_TOKEN,
        undefined,
        request
    )
    if (!response) {
        throw Error(MESSAGES.error.failedTo('Refresh Token'))
    }
    const {
        data: {
            accessToken: jwtToken,
            cumulus: { idToken, accessToken },
        },
    } = response
    const tokens = {
        jwtToken,
        idToken,
        accessToken,
    }
    return tokens
}

//MiddleLayer

interface IOtpRequestData {
    requestOtpDto: SignInFormTypes
}

export const middleLayerRequestOtp = async (data: SignInFormTypes) => {
    const sessionId = uuid4()

    setLocalState('sessionId', sessionId)

    let otpRequestData = {
        requestOtpDto: {
            ...data,
        },
    }
    try {
        const response = await Axios.middleLayerApiCall<IOtpRequestData, any>(
            AXIOS_METHODS.POST,
            MIDDLELAYER_API.REQUEST_OTP,
            undefined,
            otpRequestData
        )
        if (response) return response
        else throw new Error(MESSAGES.error.endpointError)
    } catch (error) {
        throw Error(MESSAGES.error.failedTo('signin'))
    }
}

export const handleMiddleLayerAuthentication = async (
    payload:
        | IMiddleLayerAuthenticationPayloadI
        | IMiddleLayerAuthenticationPayloadII
        | IMiddleLayerAuthenticationMultiAccountPayload,
    type: string
) => {
    const { requestDTOTitle, requestURL } = (() => {
        switch (type) {
            case USER_AUTHENTICATION_TYPE.SIGNIN:
                return {
                    requestDTOTitle: 'signInRequestDto',
                    requestURL: MIDDLELAYER_API.SIGNIN,
                }
            case USER_AUTHENTICATION_TYPE.SIGNUP:
                return {
                    requestDTOTitle: 'signUpRequestDto',
                    requestURL: MIDDLELAYER_API.SIGNUP,
                }
            case USER_AUTHENTICATION_TYPE.MULTI_ACCOUNT_SIGN_UP:
                return {
                    requestDTOTitle: 'signUpRequestDto',
                    requestURL: MIDDLELAYER_API.MULTI_ACCOUNT_SIGN_UP,
                }
            default:
                throw new Error('Invalid authentication type')
        }
    })()

    let authData = {
        [requestDTOTitle]: { ...payload },
    } as any

    if (
        'appUserKey' in payload &&
        typeof payload.appUserKey === 'string' &&
        payload.appUserKey.length
    ) {
        const { appUserKey, ...rest } = payload
        authData = {
            [requestDTOTitle]: { ...rest },
            appUserKey,
        }
    }
    try {
        const response = await Axios.middleLayerApiCall<any, any>(
            AXIOS_METHODS.POST,
            requestURL,
            undefined,
            authData
        )

        if (!response) {
            throw new Error(MESSAGES.error.invalidVerificationCode)
        }

        return response
    } catch (error: any) {
        throw new Error(error.response.data.message)
    }
}
